import { Container, Text, TextStyle } from "pixi.js"


let text: Text

export const initConsole = (container: Container) => {
  text = new Text({
    text: "",
    x: 5,
    y: 5,
    width: container.width,
    style: new TextStyle({
      fill: 0xffffff,
      fontSize: 15,
      wordWrap: true,
      fontFamily: "monospace",
    })
  })
  container.addChild(text)
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const log = (...messages: any[]) => {
  if (!text) {
    return
  }

  text.text = messages.map(e => typeof e === "object" ? JSON.stringify(e, null, 2) : e).join(" ") + " "
}

export const clear = () => {
  if (!text) {
    return
  }

  text.text = ""
}
